const CUSTOM_FNOL_FIELDS_TYPES = {
  yes_no_question: 'yes_no_question',
  yes_no_na_question: 'yes_no_na_question',
  text: 'text',
} as const;

export default CUSTOM_FNOL_FIELDS_TYPES;
